import ColumnResizer from 'column-resizer';
import React, { Component } from 'react';
import $ from 'jquery';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import Header from './header';
import Loading from '../components/Loading';
import ResultDetail from '../components/ResultDetail';
import Error504 from '../components/Error504';
import NoResult from '../components/NoResult';
import SweetAlert from 'sweetalert-react';
import ReactDOM from 'react-dom';
import listView from '../img/listView.svg';
import thumbnailView from '../img/thumbnailView.svg';
import bottomArrow from '../img/bottomArrow.svg';
import * as requestLib from '../lib/requestLib';
import { dummyTitle } from '../dummy';
import { TableTr, Card } from '../components/searchResult/index';
import WaveLoading from '../components/WaveLoading';

import { replaceThumbnails } from "../thumbnail"

const clonedeep = require("lodash/cloneDeep");


class SearchResult extends Component {
	constructor(props) {
		super(props);

		this.state = {
			filterView: 'none',
			selectGroupView: false,
			addGroupView: false,
			// domain select
			domain: {
				Protozoa: true,
				Bacteria: true,
				Archaea: true,
				Plantae: true,
				Animalia: true,
				Fungi: true,
				Chromista: true,
				Under_investigation: true,
			},
			display_options: {
				Image: true,
				Scientific_Name: true,
				Common_Name: true,
				Keywords: true,
				Science_Index: true,
			},
			// radio
			selectDate: '2',
			selectLan: '1',
			// add group
			groupName: '',
			groupSentence: '',
			groupList: [],
			posiNone: true,
			detailView: false,
			responseTableData: null,
			detail: {
				BS_id: null,
				Paper_id_list: null,
			},
			// alert
			loadingDetailAlert: false,
			loadingProps: false,
			groupNameValidation: false,
			groupSentenceValidation: false,
			// error / no result / loading
			error504: false,
			noResult: false,
			loading: false,
			tempList: null,
			loadingComplete: false,
			detailLoading: false,
			isShowToast: false,
			moveGroupNum: '',
			keywordData: [],
			resultCount: 0,
			listType: 'card',
			detailList: [],
			tableTitle: [],
			columData: [],
			items: 30,
			scrollLoading: false,
			keywordArray: [],
			keywordLoading: true
		};

		this.ref = React.createRef();
		this.tableSelector = '#testTable';
		this.baseUrl = requestLib.getUrl();
	}

	componentWillMount() {
		let url = window.location.href;
		url = url.split('?s=');
		url = url[1];
		let data, wordData;
		let keywordArry = [];
		let queryString = url, query = url;
		this.setState({ loading: true });


		if (window.location.href.indexOf('%20') > -1) {
			queryString = queryString.replace(/\%20/g, ',');
			queryString = queryString.split(',');
			query = query.replace(/\%20/g, ' ');
		} else {
			data = this.props.location.query;
			keywordArry.push(queryString);
			queryString = keywordArry;
		}
		this.setState({ keywordData: wordData });

		let response = [];
		queryString.map((item) => {
			response.push("'" + item + "'");
		})

		let Tokens = ('[' + response.join(',') + "]");

		$.ajax({
			url: `https://5othipcold.execute-api.us-west-1.amazonaws.com/TestUse?Tokens=${Tokens}`,
			method: 'get',
			contentType: 'application/json',
			dataType: 'json',

			success: function (response) {
				if (response && response !== '') {
					let relatedKeyword = response.split(';');
					relatedKeyword = relatedKeyword.map(v => v.trim());
					this.setState({ keywordArray: relatedKeyword })
				} else {
					this.setState({ keywordArray: [] })
				}
			}.bind(this),
			error: function (e) {
				this.setState({ error504: true });
			}.bind(this),
		})

		$.ajax({
			url: 'https://rrvsxm3yy3.execute-api.us-west-1.amazonaws.com/prod/search',
			data: JSON.stringify({ data: query }),
			method: 'post',
			contentType: 'application/json',
			dataType: 'json',
			success: function (res) {
				//infinite scroll 테스트용
				// res = dummyArticles
				if (res && !res.errorType) {
					// res = this.replaceImage(res.body);
					this.setState({
                        responseTableData: res.body,
                        detailList: res.body,
                        columData: res.body,
                        tableTitle: dummyTitle,
                        resultCount: new Intl.NumberFormat().format(
                            res.body.length,
                        ),
                        loadingComplete: true,
                        loading: false,
                        keywordLoading: false,
                    });


					if (res.length === 0) {
						this.setState({ noResult: true, resultCount: 0, });
					}
				} else {
					this.setState({ error504: true });
				}
			}.bind(this),
			error: function (e) {
				// console.log(e)
				this.setState({ error504: true });
			}.bind(this),
		});

		if (true) {
			this.disableResize();
		}
	}

	componentDidMount() {
		let windowHeight = $(window).height();
		let wrapHeight = $('.resultTableWrap').height();

		if (wrapHeight > windowHeight - 428) {
			this.setState({ posiNone: true });
		}

		$('.saveText').click(function () {
			$(this).toggleClass('active');
		});

		$('.saveText').blur(function () {
			$(this).removeClass('active');
		});


		let target = document.getElementById('root');
		target.addEventListener('scroll', this.handleScroll);
	}


	componentDidUpdate() {
		if (true) {
			this.enableResize();
		}
	}

	componentWillUpdate() {
		if (true) {
			this.disableResize();
		}
	}

	handleScroll = (e) => {
		let target = e.target;
		let scrollTop = target.scrollTop;
		let scrollHeight = target.scrollHeight - target.offsetHeight;
		let items = this.state.items;
		let length = this.state.responseTableData.length;

		if (
            (scrollTop === scrollHeight ||
                Math.abs(scrollTop - scrollHeight) <= 1) &&
            length > items
        ) {
            this.setState({ scrollLoading: true });
            setTimeout(() => {
                this.setState({ items: items + 30, scrollLoading: false });
            }, 350);
        }
	}

	enableResize() {
		const options = {
			resizeMode: 'fit',
			liveDrag: true,
			headerOnly: true,
			disabledColumns: [3],
			widths: [195, 307, 457, 528, 183],
			minWidth: 150,
		};

		if (this.state.listType == 'list') {
			this.resizer = new ColumnResizer(ReactDOM.findDOMNode(this).querySelector(`${this.tableSelector}`), options);
		}
	}

	disableResize() {
		if (this.resizer) {
			this.resizer.reset({ disable: true });
		}
	}

	getCookie(name) {
		let value = '; ' + document.cookie;
		let parts = value.split('; ' + name + '=');
		if (parts.length === 2) return parts.pop().split(';').shift();
	}

	replaceImage = (list) => {
		let newList = list.map(v => {
			if (v.img == 'Unknown') {
				v.img = replaceThumbnails[v.domain];
			}

			if (v.domain == "Bacteria") {
				if (v.img.indexOf('BI') > -1) {
					v.img = replaceThumbnails[v.domain];
				}
			}

			return v
		})

		return newList
	}

	getResponseTableData() {
		let tHeadTh,
			tHead,
			tBody,
			tBodyTr,
			columnNm = [],
			list = [],
			items = []



		if (this.state.responseTableData !== null) {
			items = this.state.detailList;

			list = items.slice(0, this.state.items);
			let titles = this.state.tableTitle;

			tHeadTh = titles.map((v, i) => {
				columnNm.push(v);
				return <th key={i}>{v}</th>;
			});

			tHead = (
				<thead id="resultThead">
					<tr>{tHeadTh}</tr>
				</thead>
			);

			tBodyTr = list.map((v, i) => {
				return (
					<TableTr
						showToast={this.isShowToast}
						key={i}
						resultDetail={this.resultDetail}
						trData={v}
						titles={columnNm}
						clickDetail={() => this.clickDetail()}
						keywordData={this.state.keywordData}
						detailView={this.state.detailView}
						setDetailView={() => this.setState({ detailView: true })}
					/>
				)
			})

		}

		let res =
			this.state.listType == 'list' ? (
				<table className="list" id="testTable" style={{ width: '100%!important' }}>
					{tHead}
					<tbody id="resultTbody" ref={this.ref}>
						{tBodyTr}
					</tbody>
					{this.state.scrollLoading && <WaveLoading />}
				</table>
			) : (
				<div className="card-wrapper">
					<Card
						data={list}
						resultDetail={this.resultDetail}
						clickDetail={() => this.clickDetail()}
						detailView={this.state.detailView}
						setDetailView={() => this.setState({ detailView: true })}
					/>
					{this.state.scrollLoading && <WaveLoading />}
				</div>
			);

		return res;
	}

	bodyFiltering(responseTableData) {
		let tableArray = clonedeep(responseTableData);
		let temp = [];

		// domain
		let trueDomain = [];
		if (this.state.domain.Protozoa) {
			trueDomain.push('Protozoa');
		}
		if (this.state.domain.Bacteria) {
			trueDomain.push('Bacteria');
		}
		if (this.state.domain.Archaea) {
			trueDomain.push('Archaea');
		}
		if (this.state.domain.Plantae) {
			trueDomain.push('Plantae');
		}
		if (this.state.domain.Animalia) {
			trueDomain.push('Animalia');
		}
		if (this.state.domain.Fungi) {
			trueDomain.push('Fungi');
		}
		if (this.state.domain.Chromista) {
			trueDomain.push('Chromista');
		}
		if (this.state.domain.Under_investigation) {
			trueDomain.push('Under Investigation');
		}


		tableArray.map(v => {
			if (trueDomain.includes(v.domain)) {
				temp.push(v)
			}

		})

		tableArray = temp;

		// format date
		let year = new Date().getFullYear();
		temp = []
		let e = this.state.selectDate;

		if (e === '0') {
			for (let i = 0; i < tableArray.length; i++) {
				let articles = tableArray[i].articles.filter((v, i2) => {
					if (year - 4 <= v.year && v.year <= year) {
						return v
					}
				})
				tableArray[i].articles = articles


				temp.push(tableArray[i])

			}

			temp = temp.filter(v => v.articles.length != 0);
			tableArray = temp;

			this.setState({ columData: tableArray });

		} else if (e === '1') {
			for (let i = 0; i < tableArray.length; i++) {
				let articles = tableArray[i].articles.filter((v, i2) => {
					if (year - 19 <= v.year && v.year <= year) {
						return v
					}
				})
				tableArray[i].articles = articles;
				temp.push(tableArray[i]);
			}

			temp = temp.filter(v => v.articles.length != 0);
			tableArray = temp;
			this.setState({ columData: tableArray });
		} else if (e === '2') {
			for (let i = 0; i < tableArray.length; i++) {
				if (temp.indexOf(tableArray[i]) < 0) {
					temp.push(tableArray[i]);
				}
			}

			tableArray = temp;
			this.setState({ columData: tableArray });
		}


		let displayOptions = [];
		// Display options
		if (this.state.display_options.Image) {
			displayOptions.push('Image');
		}
		if (this.state.display_options.Keywords) {
			displayOptions.push('Keywords');
		}
		if (this.state.display_options.Science_Index) {
			displayOptions.push('Science Index');
		}
		if (this.state.display_options.Scientific_Name) {
			displayOptions.push('Scientific Name');
		}
		if (this.state.display_options.Common_Name) {
			displayOptions.push('Common Name');
		}


		if (displayOptions.indexOf('Scientific Name') < 0) {
			temp = [];
			tableArray.filter((item) => {
				let obj = {};
				Object.keys(item).filter(key => {
					if (key != 'sname') {
						obj[key] = item[key];
					}
				})
				temp.push(obj)
			});
			tableArray = temp;
		}

		if (displayOptions.indexOf('Common Name') < 0) {
			temp = [];
			tableArray.map((item) => {
				let obj = {};
				Object.keys(item).filter(key => {
					if (key != 'cname') {
						obj[key] = item[key];
					}
				})
				temp.push(obj)
			});
			tableArray = temp;
		}

		if (displayOptions.indexOf('Image') < 0) {
			temp = [];
			tableArray.map((item) => {
				let obj = {};
				Object.keys(item).filter(key => {
					if (key != 'img') {
						obj[key] = item[key];
					}
				})
				temp.push(obj)
			});
			tableArray = temp;
		}

		if (displayOptions.indexOf('Keywords') < 0) {
			temp = [];
			let lists = clonedeep(tableArray);
			lists.map((item) => {
				item.articles.map((item2, index) => {
					let articles = {};
					Object.keys(item2).filter(key => {
						if (key != 'keywords') {
							articles[key] = item2[key];
						}
					})
					item.articles[index] = articles;
				})
				temp.push(item)
			});

			tableArray = temp;

		}

		if (displayOptions.indexOf('Science Index') < 0) {
			temp = [];
			let lists = clonedeep(tableArray);
			lists.map((item) => {
				item.articles.map((item2, index) => {
					let articles = {};
					Object.keys(item2).filter(key => {
						if (key != 'science_index') {
							articles[key] = item2[key];
						}
					})
					item.articles[index] = articles;
				})
				temp.push(item)
			});

			tableArray = temp;

		}

		this.setState({ detailList: tableArray })
	}

	headerFiltering(titles) {
		let displayOptions = [];
		// Display options
		if (this.state.display_options.Image) {
			displayOptions.push('Image');
		}
		if (this.state.display_options.Keywords) {
			displayOptions.push('Keywords');
		}
		if (this.state.display_options.Science_Index) {
			displayOptions.push('Science Index');
		}

		if (displayOptions.indexOf('Image') < 0) {
			titles = titles.filter(v => v !== 'Image');
		}

		if (displayOptions.indexOf('Keywords') < 0) {
			titles = titles.filter(v => v !== 'Keywords');
		}

		if (displayOptions.indexOf('Science Index') < 0) {
			titles = titles.filter(v => v !== 'Science Index');
		}

		this.setState({ tableTitle: titles });

	}


	domainChange(e, domainName) {
		let domain = this.state.domain;
		domain[domainName] = e.target.checked;

		this.setState({ domain: domain });
	}

	formatChange(e) {
		this.setState({ selectDate: e.target.value });
	}

	usageChange(e, options) {
		let display_options = this.state.display_options;
		display_options[options] = e.target.checked;

		this.setState({ display_options });
	}

	lanChange(e) {
		this.setState({ selectLan: e.target.value });
	}

	clickDetail() {
		this.setState({ detailLoading: true });
	}

	isShowToast = (groupNum) => {
		this.setState({ isShowToast: false });

		this.setState({ isShowToast: true });

		setTimeout(
			function () {
				this.setState({ isShowToast: false });
			}.bind(this),
			5000
		);

		this.setState({ moveGroupNum: groupNum });
		// console.log(groupNum);
	};

	searchListType(e) {
		e.preventDefault();
		let currentTarget = e.currentTarget,
			id = currentTarget.id,
			listType = 'list';
		if (id == 'list') {
			let next = currentTarget.nextElementSibling;
			next.classList.remove('active-view');
			listType = 'list';
		} else if (id == 'card') {
			let prev = currentTarget.previousElementSibling;
			prev.classList.remove('active-view');
			listType = 'card';
		}
		currentTarget.classList.add('active-view');

		this.setState({ listType, items: 30 });
	}

	listOptionsHandle() {
		const filters = document.querySelector('.filterTitle');

		let existClass = filters.classList.contains('active');

		if (existClass) {
			filters.classList.remove('active');
		} else {
			filters.classList.add('active');
		}
	}

	filterHandle = () => {
		this.bodyFiltering(this.state.responseTableData);
		this.headerFiltering(dummyTitle);
	}

	render() {
		let addGroupView;
		let error504;
		let noResult;
		let loading;
		let header;
		let detailLoading;


		if (this.state.addGroupView) {
			addGroupView = (
				<div className="overlay">
					<div className="addGroupForm">
						<span onClick={() => this.setState({ addGroupView: false })}>&times;</span>
						{/*<i className="fas fa-times" onClick={ () => this.setState({addGroupView:false})}></i>*/}
						<h1>Create a New Group</h1>
						<input
							type="text"
							placeholder="Group Name"
							value={this.state.groupName}
							onChange={(e) => this.setState({ groupName: e.target.value })}
						/>
						<input
							type="text"
							placeholder="Please describe this group in a sentence."
							value={this.state.groupSentence}
							onChange={(e) => this.setState({ groupSentence: e.target.value })}
						/>
						<SweetAlert
							show={this.state.groupNameValidation}
							title="You must fill in both fields."
							text=""
							onConfirm={() => {
								this.setState({ groupNameValidation: false });
							}}
						/>
						<SweetAlert
							show={this.state.groupSentenceValidation}
							title="You must fill in both fields."
							text=""
							onConfirm={() => {
								this.setState({
									groupSentenceValidation: false,
								});
							}}
						/>
						<button onClick={this.addGroup.bind(this)}>Create</button>
					</div>
				</div>
			);
		}

		if (this.state.error504) {
			error504 = <Error504 groupList={this.state.groupList} />;
		}

		if (this.state.noResult) {
			noResult = <NoResult groupList={this.state.groupList} />;
		}

		if (this.state.loading && this.state.keywordLoading) {
			loading = <Loading />;
		}
		if (this.state.loadingComplete && !this.state.keywordLoading) {
			header = <Header list={this.state.responseTableData} keywordArray={this.state.keywordArray} groupList={this.state.groupList} />;
		}

		if (this.state.detailLoading) {
			detailLoading = (
				<div className="detailLoadingWrap">
					<div className="lds-spinner">
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
					</div>
				</div>
			);
		}

		return (
			<div id="searchResult" className="wrap" ref={this.scrollRef}>
				{header}
				{loading}
				{noResult}
				{error504}
				<div className={this.state.isShowToast ? 'toastMessageWrap active' : 'toastMessageWrap'}>
					<p>document is successfully bookmarked!</p>
					<a href={this.baseUrl + 'group/info/' + this.state.moveGroupNum}>move to the group</a>
				</div>
				<div className="searchFilter wrap">
					<div className="wrap1120">
						<ul className="list-option-wrap">
							<li key="list-option1" className="list-result">
								<p className="result-count">{this.state.resultCount}</p>
								<p>search results</p>
							</li>
							<li key="list-option2">
								<button className="list-options" onClick={() => this.listOptionsHandle()}>
									List options <img src={bottomArrow} />
								</button>
							</li>
							<li key="list-option3">
								<button id="list" className="list-type" onClick={(e) => this.searchListType(e)}>
									<img src={listView} alt="" />
								</button>
								<button id="card" className="list-type active-view" onClick={(e) => this.searchListType(e)}>
									<img src={thumbnailView} alt="" />
								</button>
							</li>
						</ul>
						<div className="filterTitle">
							<ul className="filterTitle-lists">
								<li>
									Domain &nbsp;
									<ul
										className={this.state.filterView === 'domain' ? 'chkLabel active' : 'chkLabel'}
										onClick={(e) => e.stopPropagation()}
										id="domainUl"
									>
										<li>
											<input
												type="checkbox"
												id="Protozoa"
												onChange={(e) => this.domainChange(e, 'Protozoa')}
												checked={this.state.domain.Protozoa}
											/>
											<label htmlFor="Protozoa">Protozoa</label>
										</li>
										<li>
											<input
												type="checkbox"
												id="Bacteria"
												onChange={(e) => this.domainChange(e, 'Bacteria')}
												checked={this.state.domain.Bacteria}
											/>
											<label htmlFor="Bacteria">Bacteria</label>
										</li>
										<li>
											<input
												type="checkbox"
												id="Archaea"
												onChange={(e) => this.domainChange(e, 'Archaea')}
												checked={this.state.domain.Archaea}
											/>
											<label htmlFor="Archaea">Archaea</label>
										</li>
										<li>
											<input
												type="checkbox"
												id="Plantae"
												onChange={(e) => this.domainChange(e, 'Plantae')}
												checked={this.state.domain.Plantae}
											/>
											<label htmlFor="Plantae">Plantae</label>
										</li>
										<li>
											<input
												type="checkbox"
												id="Animalia"
												onChange={(e) => this.domainChange(e, 'Animalia')}
												checked={this.state.domain.Animalia}
											/>
											<label htmlFor="Animalia">Animalia</label>
										</li>
										<li>
											<input
												type="checkbox"
												id="Fungi"
												onChange={(e) => this.domainChange(e, 'Fungi')}
												checked={this.state.domain.Fungi}
											/>
											<label htmlFor="Fungi">Fungi</label>
										</li>
										<li>
											<input
												type="checkbox"
												id="Chromista"
												onChange={(e) => this.domainChange(e, 'Chromista')}
												checked={this.state.domain.Chromista}
											/>
											<label htmlFor="Chromista">Chromista</label>
										</li>
										<li>
											<input
												type="checkbox"
												id="Under_investigation"
												onChange={(e) => this.domainChange(e, 'Under_investigation')}
												checked={this.state.domain.Under_investigation}
											/>
											<label htmlFor="Under_investigation">Under investigation</label>
										</li>
									</ul>
								</li>
								<li>
									Format date &nbsp;
									<ul
										className={this.state.filterView === 'date' ? 'chkLabel li3 active' : 'chkLabel li3'}
										onClick={(e) => e.stopPropagation()}
										id="dateUl"
									>
										<li>
											<input
												type="radio"
												id="years5"
												value="0"
												checked={this.state.selectDate === '0'}
												onChange={(e) => this.formatChange(e)}
											/>
											<label htmlFor="years5">Last 5 years</label>
										</li>
										<li>
											<input
												type="radio"
												id="years20"
												value="1"
												checked={this.state.selectDate === '1'}
												onChange={(e) => this.formatChange(e)}
											/>
											<label htmlFor="years20">Last 20 years</label>
										</li>
										<li>
											<input
												type="radio"
												id="Anytime"
												value="2"
												checked={this.state.selectDate === '2'}
												onChange={(e) => this.formatChange(e)}
											/>
											<label htmlFor="Anytime">Anytime</label>
										</li>
									</ul>
								</li>
								<li>
									Display options &nbsp;
									<ul
										className={this.state.filterView === 'usage' ? 'chkLabel li3 active' : 'chkLabel li3'}
										onClick={(e) => e.stopPropagation()}
										id="usageUl"
									>
										<li>
											<input
												type="checkbox"
												value="0"
												id="Image"
												checked={this.state.display_options.Image}
												onChange={(e) => this.usageChange(e, 'Image')}
											/>
											<label htmlFor="Image">Image</label>
										</li>
										<li>
											<input
												type="checkbox"
												value="1"
												id="Keywords"
												checked={this.state.display_options.Keywords}
												onChange={(e) => this.usageChange(e, 'Keywords')}
											/>
											<label htmlFor="Keywords">Keywords</label>
										</li>
										<li>
											<input
												type="checkbox"
												value="2"
												id="Science_Index"
												name="usageRights"
												checked={this.state.display_options.Science_Index}
												onChange={(e) => this.usageChange(e, 'Science_Index')}
											/>
											<label htmlFor="Science_Index">Science Index</label>
										</li>
										<li>
											<input
												type="checkbox"
												value="3"
												id="Scientific_Name"
												name="usageRights"
												checked={this.state.display_options.Scientific_Name}
												onChange={(e) => this.usageChange(e, 'Scientific_Name')}
											/>
											<label htmlFor="Scientific_Name">Scientific Name</label>
										</li>
										<li>
											<input
												type="checkbox"
												value="4"
												id="Common_Name"
												name="usageRights"
												checked={this.state.display_options.Common_Name}
												onChange={(e) => this.usageChange(e, 'Common_Name')}
											/>
											<label htmlFor="Common_Name">Common Name</label>
										</li>
									</ul>
								</li>
							</ul>
							<button className="apply" onClick={() => this.filterHandle()}>Apply option</button>
						</div>
					</div>
				</div>

				<div
					className="resultTableWrap wrap"
					style={{
						paddingBottom: this.state.posiNone ? '0' : '200px',
					}}
				>
					<div className="wrap1740">
						{addGroupView}

						{this.getResponseTableData()}
					</div>
					{detailLoading}

					<Footer posiNone={this.state.posiNone} />
				</div>

				<ResultDetail
					ref={(ref) => {
						this.resultDetail = ref;
					}}
					Paper_list={this.state.detail.Paper_id_list}
					BS_id={this.state.detail.BS_id}
					detailView={this.state.detailView}
					clickCloseArticle={() => this.setState({ detailView: false })}
					endloaded={() => this.setState({ detailLoading: false })}
					groupUpdate={(groupData) => this.setState({ groupList: groupData })}
					articles={this.state.columData}
					showToast={(num) => this.isShowToast(num)}
				/>
			</div>
		);
	}
}

export default SearchResult;



// WEBPACK FOOTER //
// ./src/pages/searchResult.js